import { __assign } from "tslib";
// DS: C49
/** A floating panel for selecting collections where the given deviation will be added to */
import React, { useContext } from 'react';
import MobileCollectionPopup from './MobileCollectionPopup';
import DesktopCollectionPanel from './DesktopCollectionPanel';
import { MobileContext } from '../Context';
import { getDeviationNotificationQueue } from '../DeviationPage/redux/helpers';
export var CollectionPanel = function (props) {
    var isMobile = useContext(MobileContext);
    if (isMobile) {
        return React.createElement(MobileCollectionPopup, __assign({}, props));
    }
    return (React.createElement(DesktopCollectionPanel, __assign({ notificationQueue: getDeviationNotificationQueue(props.collectibleDeviation) }, props)));
};
export default CollectionPanel;
//# sourceMappingURL=CollectionPanel.js.map